import { LimitMessage } from '@aibees/elephant/feature/suggestion-search-bar/components/limit-message';
import { useSuggestionSearchBarContext } from '@aibees/elephant/feature/suggestion-search-bar/context';
import { classnames } from '@aibees/shared/utils';
import { Skeleton, Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ItemWrapperProps as Props } from './types';

export const ItemWrapper = memo(({ className, children }: Props) => {
  const { isOptionsLoading } = useSuggestionSearchBarContext();

  return (
    <Styled.Wrapper
      className={classnames('ItemWrapper', className)}
      sx={SX.root}
    >
      <Stack gap={1}>
        <LimitMessage />
        {isOptionsLoading
          ? [1, 2, 3, 4, 5, 6].map((x, v) => (
              <Skeleton
                key={v}
                animation="wave"
                variant="rounded"
                sx={SX.skeleton}
              />
            ))
          : children}
      </Stack>
    </Styled.Wrapper>
  );
});

ItemWrapper.displayName = 'ItemWrapper';
